import Vue from "vue";
import App from "./App.vue";
import VueTour from "vue-tour";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import moment from "moment";
import vuetify from "./plugins/vuetify";
import "@babel/polyfill";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";
import NoNavbar from "./Layout/NoNavbar";
import Default from "./Layout/Default";
import Error from "./Layout/Error";
import IcFirebaseUploader from "ic-firebase-uploader";
import "ic-firebase-uploader/dist/ic-firebase-uploader.min.css";
import VueCosha from "vue-cosha";
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";
import CommentGrid from "./components/Comments";
import i18n from "./i18n";
import PerfectScrollbar from "vue2-perfect-scrollbar";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";
import { EventBus } from "@/eventBus";
import { firestorePlugin } from "vuefire";
import { setLanguage } from "firebase-error-translator";
setLanguage("fr");

const firebase = require("../firebase.config.js");

const requireComponent = require.context("@/components/base", true, /\.vue$/);

require("vue-tour/dist/vue-tour.css");

Vue.use(firestorePlugin);
Vue.use(VueTour);
Vue.use(PerfectScrollbar);

Vue.config.productionTip = false;

Vue.component("no-navbar-layout", NoNavbar);
Vue.component("default-layout", Default);
Vue.component("error-layout", Error);
Vue.component("ic-firebase-uploader", IcFirebaseUploader);

Vue.config.errorHandler = function(err, vm, info) {
  if(err.message === "Cannot read properties of undefined (reading 'catch')") return;
  EventBus.$emit("showSnackBar", {
    message: `${err.toString()}\n : ${info}`,
    type: "error"
  });
};

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName);

  const componentName = upperFirst(
    camelCase(fileName.replace(/^\.\//, "").replace(/\.\w+$/, ""))
  );

  Vue.component(
    `Base${componentName}`,
    componentConfig.default || componentConfig
  );
});

Vue.config.devtools = true;
Vue.use(CommentGrid);
Vue.use(VueCosha, {
  blur: "5px",
  brightness: 1,
  saturation: 1,
  x: 0,
  y: 0
});
Vue.use(Viewer);

Vue.filter("formatDate", function(value) {
  if (value) {
    return moment(String(value)).format("DD/MM/YYYY");
  }
});

let app = "";

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requiresAuth && !(await firebase.getCurrentUser())) {
    next("/login");
  } else if (store.getters["user/isUserDisabled"]) {
    next("/successfull-registration");
  } else {
    next();
  }
});

firebase.auth().onAuthStateChanged(async firebaseUser => {
  if (firebaseUser) {
    await firebase.usersCollection
      .doc(firebaseUser.email)
      .onSnapshot(querySnapshot => {
        const user = querySnapshot.data();
        user.uid = firebaseUser.uid;
        store.dispatch("user/fetchUser", user);
      });
    store.dispatch("activities/fetchActivities");
  }

  if (!app) {
    app = new Vue({
      router,
      store,
      firebase,
      vuetify,
      i18n,
      render: h => h(App)
    }).$mount("#app");
  }
});
